import { isSSR, isWebView, withParams } from '@telialt/utils/src/helpers';
import { getSegment, TeliaSegment } from '@telialt/utils/src/segment';

import { getAgreementId, PATHS, SELF_SERVICE_PATH_PREFIX } from '../constants';

const removeQueryString = (path: string) => {
    return path.split(/[?#]/)[0];
};

const isAbsoluteUrl = (path: string) => {
    return /^(?:[a-z]+:)?\/\//i.test(path);
};

const getPathFromLink = (link: string, includeQuery?: boolean) => {
    const currentHostname = process.env.IS_NEXT !== 'true' ? window.location.hostname : '';
    let linkPathname = link;
    if (isAbsoluteUrl(link)) {
        const url = new URL(link);
        linkPathname = url.hostname === currentHostname || process.env.IS_NEXT === 'true' ? url.pathname : link;
    }

    const path = linkPathname;
    const pathForTrimming = !includeQuery ? removeQueryString(path) : path;

    return pathForTrimming.endsWith('/') ? pathForTrimming.slice(0, -1) : pathForTrimming;
};

export const getIsLinkActive = (
    linkUrl: string,
    currentPath?: string,
    partialMatch?: boolean,
    includeQuery?: boolean,
) => {
    const path = getPathFromLink(linkUrl, includeQuery);
    const preparedCurrentPath = getPathFromLink(currentPath, includeQuery);

    if (partialMatch) {
        return preparedCurrentPath?.startsWith(path);
    }

    return preparedCurrentPath === path;
};

export const getIsExManoTeoLinkActive = (linkUrl: string, currentPath?: string) => {
    const search = typeof window !== 'undefined' ? window.location.search : '';

    return getIsLinkActive(linkUrl, `${currentPath}${search}`, undefined, true);
};

export const getIsLoginPath = (path: string) => {
    return path.startsWith(PATHS.LOGIN[TeliaSegment.B2c]) || path.startsWith(PATHS.LOGIN[TeliaSegment.B2b]);
};

export const getIsIdentification = (path: string) => {
    return path.startsWith(PATHS.IDENTIFICATION[TeliaSegment.B2b]);
};

export const getIsSelfService = (path: string) => {
    return path.startsWith(SELF_SERVICE_PATH_PREFIX);
};

export const getIsMyAccountPath = (path: string) => {
    return path.startsWith(PATHS.MY_ACCOUNT[TeliaSegment.B2c]) || path.startsWith(PATHS.MY_ACCOUNT[TeliaSegment.B2b]);
};

export const getIsContactsAndPrivacyPath = (path: string) => {
    return (
        path.startsWith(PATHS.CONTACTS_PRIVACY[TeliaSegment.B2c]) ||
        path.startsWith(PATHS.CONTACTS_PRIVACY[TeliaSegment.B2b])
    );
};

export const getIsEmptyAgreementsPath = (path: string) => {
    return path.startsWith(PATHS.SEGMENT[TeliaSegment.Fix].noBusinessAgreements);
};

export const getB2bUrl = (url: string) => {
    return withParams(url, { agreementId: getAgreementId() });
};

export const getHomeUrl = (currentPath: string, customUrl?: string) => {
    const segment = getSegment(currentPath);
    const isSelfService = getIsSelfService(currentPath);
    const isLogin = getIsLoginPath(currentPath);
    const isIdentification = getIsIdentification(currentPath);
    const url = PATHS.LOGO[isSelfService && !isLogin && !isIdentification ? 'selfService' : 'public'][segment];

    return !isSSR() && isWebView() ? null : (customUrl ?? url);
};
